import { createApp } from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router'
import store from './store'
import i18n from "@/languages";



createApp(App).use(Vant).use(store).use(router).use(i18n).mount('#app')
